import axios from "axios";
import { getConfigHeader, refrech, URL_DOWNLOAD_FILE } from "./config";

export const getSalariePhoto = async (filename) => {
  return refrech()
    .then(() =>
      axios.get(URL_DOWNLOAD_FILE + `?salariephoto=${filename}`, {
        ...getConfigHeader(),
        responseType: "blob",
      })
    )
    .catch((error) => Promise.reject(error));
};

export const getUserPhoto = async (filename) => {
  return refrech()
    .then(() =>
      axios.get(URL_DOWNLOAD_FILE + `?userphoto=${filename}`, {
        ...getConfigHeader(),
        responseType: "blob",
      })
    )
    .catch((error) => Promise.reject(error));
};
